import React from 'react';
class Forbidden extends React.Component {
    render() {
        const referrer = document.referrer;
        console.log(referrer, 'referrer2');
        return (
            <div style={{ textAlign: "center" }}>
                Please join the class through the LMS or App only. Copying, pasting, or altering the URL may cause the link to break.

            </div>

        );
    }
}

export default Forbidden;
